import './App.css';
import FirstCard from "./FirstCard";

function App() {
 return (
  <div className="App" style={{ width: "100rem" }}>
      <FirstCard defaultCity="Los Angeles" />
    </div>
  );
}

export default App;
